import styled, { css } from "styled-components";
import { Tick as TickIcon } from "@nested/ui/icons";

const Input = styled.input`
  display: none;
`;

const Tick = styled(TickIcon)`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  left: 0;
`;

const BoxWrapper = styled.div`
  width: 20px;
  padding-top: 7px;
`;

const Box = styled.div`
  position: relative;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  background-color: white;
  ${({ highContrast }) =>
    highContrast
      ? css`
          border: 1px solid #bbb;
        `
      : css`
          box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.05);
          border: 1px solid #f5f5f5;
        `};
`;

const Label = styled.label`
  display: flex;
  flex-direction: row;
`;

const LabelText = styled.div`
  padding-left: 20px;
  line-height: 29px;
  color: ${({ theme }) => theme.palette.hague};
  font-weight: 300;
`;

export const Checkbox = ({
  "data-test": dataTest,
  label,
  name,
  checked,
  onChange,
  highContrast,
}) => (
  <Label>
    <BoxWrapper>
      <Input
        checked={checked}
        onChange={onChange}
        name={name}
        type="checkbox"
      />
      <Box highContrast={highContrast} data-test={dataTest}>
        {checked && <Tick />}
      </Box>
    </BoxWrapper>
    <LabelText>{label}</LabelText>
  </Label>
);
